import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchKitchens = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/kitchens', { pagination: false }).then(kitchens => {
    dispatch({
      type: types.FETCH_KITCHENS,
      payload: {
        kitchens: kitchens['hydra:member'],
      },
    });
  });
